// src/pages/RunForm.jsx
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";
import RunFormFields from "../components/RunFormFields";

export default function RunForm() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const preselectId = params.get("dict") || "";

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, borderRadius: 2 }}>
        <Typography variant="h5" fontWeight={700} mb={2}>New analysis</Typography>
        <RunFormFields
          preselectDictId={preselectId}
          onCancel={() => nav(-1)}
          onSuccess={(runId) => nav(`/runs/${encodeURIComponent(runId)}`)}
        />
      </Paper>
    </Box>
  );
}